import { TextField } from "@mui/material";

// Utility function to generate detached outlined styles
const getDetachedOutlinedStyles = (hasLabel: boolean, size?: string) => ({
  "& .MuiInputLabel-root.MuiInputLabel-shrink": {
    top: "-23px",
    left: "4px",
    fontSize: "14px",
    fontWeight: "600",
    color: "#3D3D3D",
  },
  "& .MuiOutlinedInput-root": {
    input: {
      marginTop: "0px",
    },
    ...(size === "small" && {
      minHeight: "48px",
    }),
  },
  ...(size === "small" && {
    input: {
      marginTop: "0px",
    },
  }),
  marginTop: hasLabel ? "23px" : "0px",
});

const TextFieldWrapper = ({ ...props }) => {
  const updatedProps = {
    ...props,
    variant: props.variant === "detachedOutlined" ? "outlined" : props.variant,
  };

  // Simple conditional sx building
  const sx =
    props.variant === "detachedOutlined"
      ? {
          ...getDetachedOutlinedStyles(!!props.label, props.size),
          ...props.sx, // Parent sx comes last to allow overrides
        }
      : props.sx;

  return <TextField {...updatedProps} sx={sx} />;
};

export default TextFieldWrapper;
